import React, { useRef, useEffect, useState } from 'react';
import { Container, Typography, Grid, Table, TableBody, TableCell, TableContainer, TableHead, TableRow, Paper, Button, LinearProgress } from '@mui/material';
import ReactToPrint from 'react-to-print'; // Optional: You can use react-to-print for better control
import axios from 'axios';
import InvoiceDisplay from './InvoiceDisplay';
import jsPDF from 'jspdf';
import html2canvas from 'html2canvas';
import Filters from './Filters'; 
import { Box} from '@mui/material';
import NoMatchingRecords from './components/NoMatchingRecords';
import { useT } from '../i18n/LanguageContext';


// Main App Component
const CreateInvoice = ({ embedded = false }) => {
  const t = useT();
  const [loading, setLoading] = useState(false);  
  const [error, setError] = useState(null);
  const [filterData, setFilterData] = useState([]);
  const [searched, setSearched] = useState(false);
  const [needsCompany, setNeedsCompany] = useState(false);

  

const [invoiceData, setInvoiceData] = useState([]);
  //const invoices=[];

  // useEffect(() => {
  //   const fetchData = async () => {
  //     try {
  //       // Replace with your actual API endpoint
  //       const response = await axios.get('http://192.168.1.215:8080/api/invoice/createInvoice');
       
  //       setInvoiceData(response.data);  
  //       setLoading(false);
  //     } catch (err) {
  //       setError('Error creating invoice');
  //       setLoading(false);
  //     }
  //   };

  //   fetchData();
  // }, []);

  // Function that will be passed to the Filters component
  const handleFilterChange = async (filterData) => {    
    setError(null);
    setInvoiceData([]);
    // The invoice is per sub contractor — with neither one nor a truck picked there is nothing to bill.
    if (!filterData.company && !filterData.truck) {
      setSearched(false);
      setNeedsCompany(true);
      return;
    }
    setNeedsCompany(false);
    setLoading(true);
    setSearched(true);
    try {
      const apiUrl = process.env.REACT_APP_API_URL;
      // Replace with your actual API endpoint
      const response = await axios.get(`${apiUrl}/api/invoice/createInvoice`, {
        params: filterData
      });     
      setFilterData(filterData);
      setInvoiceData(response.data);  
    } catch (err) {
      setError('Error creating invoice');
    } finally {
      setLoading(false);
    }
  };  

   // Create refs for each invoice
   const invoiceRefs = useRef([]);

   const handlePrint = (index) => {
     const printableContent = invoiceRefs.current[index];
     const printWindow = window.open('', '_blank');
     printWindow.document.write('<html><head><title>Print</title></head><body>');
     printWindow.document.write(printableContent.outerHTML);
     printWindow.document.write('</body></html>');
     printWindow.document.close();
     printWindow.focus();
     printWindow.print();
     printWindow.close();
   };

   // Function to handle generating a PDF for an invoice
  const handleGeneratePDF = (index) => {
    const input = invoiceRefs.current[index]; // The specific invoice to convert to PDF
    html2canvas(input).then((canvas) => {
      const imgData = canvas.toDataURL('image/png');
      const pdf = new jsPDF();
      pdf.addImage(imgData, 'PNG', 0, 0, 210, 297); // A4 size page dimensions
      pdf.save(`invoice_${index + 1}.pdf`);
    });
  };

  const handleDownloadPdf = async () => {
    try {
      const apiUrl = process.env.REACT_APP_API_URL;
      // Call the Spring Boot API to generate the PDF
      const response = await axios.get(`${apiUrl}/api/invoice/create-invoice-pdf`, {
        params: filterData,
        responseType: 'blob', // Ensure the response is treated as a binary file
      });


      // Create a download link and trigger it
      const url = window.URL.createObjectURL(new Blob([response.data]));
      const link = document.createElement('a');
      link.href = url;
      const now = new Date();

      const date = now.toLocaleDateString();   // e.g., "10/26/2024"
      const time = now.toLocaleTimeString();
      
      link.setAttribute('download', filterData.companyName.replace(' ','-')+'_invoice' +"_"+date+"_"+time+".pdf"); // Set the download filename

      document.body.appendChild(link);
      link.click();
      link.remove();
    } catch (error) {
      console.error('Error downloading the PDF', error);
    }
  };





   return (
        <Box sx={{ maxWidth: 1280, mx: 'auto', p: { xs: 2, md: 3 } }}>

        {!embedded && <Box sx={{ mb: 1 }}><h2 style={{ margin: 0 }}>{t('inv.createTitle')}</h2></Box>}
        {/* Pass handleFilterChange as the onFilterChange prop */}

         <Filters onFilterChange={handleFilterChange} ScreenName={"Create Invoice"} showPlant />

         {loading && (
           <Box sx={{ mb: 2 }}>
             <LinearProgress />
             <Typography sx={{ fontSize: 12, color: 'text.secondary', mt: 0.5 }}>{t('common.loading')}</Typography>
           </Box>
         )}

         {needsCompany && (
           <Typography sx={{ mx: { xs: 0, md: 4 }, mb: 2, color: 'text.secondary' }}>
             {t('inv.pickCompany')}
           </Typography>
         )}

         {/* Errors show under the filters so you can change them and search again. */}
         {error && (
           <Typography variant="h6" color="error" sx={{ mx: { xs: 0, md: 4 }, mb: 2 }}>{error}</Typography>
         )}

         {searched && !loading && !error && invoiceData.length === 0 && (
           <NoMatchingRecords sx={{ mx: { xs: 0, md: 4 }, mb: 2 }} />
         )}

          
         {invoiceData.length > 0 && (
           <Box sx={{ mt: 2, mb: 1 }}>
             <Typography variant="subtitle1" sx={{ fontWeight: 600 }}>
               {t('inv.countSummary', {
                 inv: invoiceData.length,
                 tickets: invoiceData.reduce((sum, inv) => sum + (inv.invoiceOcrDetailsList?.length || 0), 0),
               })}
             </Typography>
           </Box>
         )}

         {invoiceData.length > 0  && (
            <Box sx={{ display: 'flex', justifyContent: 'flex-end', mb: '30px' }}>
              <Button variant="contained" color="secondary" onClick={() => handleDownloadPdf()} sx={{ width: { xs: '100%', sm: 'auto' } }}>
                {t('inv.createPdf')}
              </Button>
            </Box>


       )}


{invoiceData.length > 0  && (      
      invoiceData?.map((invoice, index) => (
        <div key={index}>
          <InvoiceDisplay ref={(el) => (invoiceRefs.current[index] = el)} invoiceData={invoice} />                
        </div>
      ))
    
       )}
        </Box>
    );
  
};

export default CreateInvoice;
